module.exports = __webpack_public_path__ + "img/bg-mbl-undefined.ffe91dd2.png";